module.exports = __webpack_public_path__ + "static/images/document-checked.23MLBt9.svg";